import type { NamedSet } from 'zustand/middleware';

import type { ZustandStore } from '../store.type';

export type RoleMappedToTsId = {
	id: string;
	label: string;
	mappedTSRoleId: string;
};

type RolesMappedToTsId = {
	teamAdmin: RoleMappedToTsId;
	manager: RoleMappedToTsId;
	teamMember: RoleMappedToTsId;
};

type RolesState = {
	role: {
		roles: Partial<RolesMappedToTsId>;
	};
};

type SetRolesArgs = {
	roles: RolesState['role']['roles'];
};

type RolesActions = {
	setRoles: ({ roles }: SetRolesArgs) => void;
};

export type RolesSlice = RolesState & RolesActions;

const rolesInitialState: RolesState = {
	role: {
		roles: {} as RolesMappedToTsId,
	},
};

export function rolesSlice(set: NamedSet<ZustandStore>): RolesSlice {
	return {
		...rolesInitialState,
		setRoles({ roles }: SetRolesArgs): void {
			set(
				(state: RolesState) => {
					state.role.roles = roles;
					return state;
				},
				false,
				'[setRoles]',
			);
		},
	};
}
